import { first, last } from "lodash";
import { Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";
import { Id } from "PFTypes";

import { BookingRowsContextType } from "./booking_rows_context";

type RowsByKey = BookingRowsContextType["rowsByKey"];

export const findClosestParent = (row: Row, rowsByKey: RowsByKey): Row | undefined => {
  const closestParentKey = last(row.parents);
  return closestParentKey ? rowsByKey[closestParentKey] : undefined;
};

export const findRootParent = (row: Row, rowsByKey: RowsByKey): Row => {
  const rootParentKey = first(row.parents);
  return rootParentKey ? rowsByKey[rootParentKey] : row;
};

export const filterRolesByActivityId = (activityId: Id, rows: Row[]): Row[] => {
  const activityRow = rows.find((row) => row.original?.id === activityId);
  if (!activityRow || ![RowType.Role, RowType.Engagement].includes(activityRow?.type)) {
    return [];
  }
  if (activityRow?.type === RowType.Role) {
    return [activityRow];
  }
  const engagementKey = activityRow?.key;
  return rows.filter(({ key, type }) => key.startsWith(engagementKey) && type === RowType.Role);
};
